import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();

    const goHome = () => {
        navigate("/");
    }

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-md">
                <h1 className="text-4xl font-bold mb-4">
                    Sorry, we couldn't find the page!
                </h1>
                <p className="text-gray-600">
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
                <div className="btn mt-10" onClick={goHome}>Go Home</div>
            </div>
        </div>
    );
};

export default PageNotFound;
